import React, { Component, useState, useEffect } from 'react';
import { connect } from "react-redux";
import iconRight from '../../../assets/images/Icon-arrow-right.png'
import { fileUpload, AddWarrantyExpiration } from "../../../store/actions";
import uploadIcon from '../../../assets/images/Icon feather-upload-cloud.png';
import { Buffer } from 'buffer';

class AddPurchaseOrders extends Component {
  constructor(props) {
    super(props);


  }
  state = {
    purchaseDate: "",
    deliveryDate: "",
    isChecked: false,
    isAddOrderShow: this.props.isAddOrderShow,
    dragging: false,
    src: null,
    file: null,
    imageFileError: false,
    itemFileName: "",
    statusList: [],
    expirationDate: new Date()
  }
  componentDidMount() {

  }
  purchaseDate = (e) => {
    this.setState({ purchaseDate: e });
  };
  deliveryDate = (e) => {
    this.setState({ deliveryDate: e });
  };

  onSelectFile = (e, drop) => {
    let file = drop ? e.dataTransfer.files[0] : e.target.files[0];
    if (!file) return;
    let reader = new FileReader();
    this.setState({
      file: file,
      imageFileError: null,
      itemFileName: file.name,
    });
    reader.readAsDataURL(file);
    let src;
    reader.onload = (res) => {
      src = res.target.result;
      const i = src.indexOf("base64,");
      const buffer = Buffer.from(src.slice(i + 7), "base64");
      const _file = new File([buffer], file.name, {
        type: file.type
      });
      const fd = new FormData();
      fd.append("file", _file);
      fd.append("filename", _file.name);
      fd.append("container", "pcpayadmin");
      fileUpload(fd).then(result => {
        this.setState({ imageUrl: result, src });
      });
    }

  };


  AddOrder = async ($e) => {
    $e.preventDefault();
    let date = new Date();
    let payload = {
      orderID: this.state.orderID,
      itemImage: this.state.imageUrl,
      itemName: this.state.itemName,
      itemDescription: this.state.description,
    }
    //await this.props.AddItemOrder(payload);
    this.props.closeSidebar()
  }


  render() {
    return (

      <>
        <div className={`AddPurchaseOrders`} >
          <div className="overlay-pop" onClick={this.props.closeSidebar}></div>
          <form onSubmit={this.AddOrder} >
            <div className="userHeader d-flex align-items-center justify-content-between">
              <div className="UserName">
                <h2>Add Item</h2>
              </div>
              <div className="iconRight" onClick={this.props.closeSidebar}>
                <img src={iconRight} alt=""></img>
              </div>
            </div>
            <div className="item-body">
              <div className="itemList">
                <div className="itemLabel">
                  <span>Image</span>
                </div>
                <div
                  className="itemOutput_full file-area"
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}
                >
                  <label
                    onDrop={(e) => {
                      this.setState({ dragging: false });
                      e.preventDefault();
                      this.onSelectFile(e, true);
                    }}
                    onDragOver={(e) => {
                      this.setState({ dragging: true });
                      e.preventDefault();
                    }}
                    onDragEnd={() => this.setState({ dragging: false })}
                    onDragLeave={() => this.setState({ dragging: false })}
                    htmlFor="upload_image"
                    className={`df acc upload_lbl ${this.state.itemFileName
                      ? "selected " +
                      this.state.itemFileName
                        .substring(
                          this.state.itemFileName.lastIndexOf(".") + 1,
                          this.state.itemFileName.length
                        )
                        .toLowerCase()
                      : ""
                      } ${this.state.dragging ? "dragging" : ""}`}
                  >
                    {!this.state.itemFileName && (
                      <label htmlFor="upload_image">
                        <img className="uploadIcon" src={uploadIcon} alt="" />
                        <span className="fwc fwsb5 fs16">Upload Product Image</span>
                      </label>
                    )}

                    {this.state.itemFileName && (
                      <div className="upload_label">
                        <img className="thambsImage" src={this.state.src} alt={this.state.itemFileName} />
                      </div>
                    )}
                    <input
                      accept=".PNG,.png,.jpg,JPEG"
                      className="dn"
                      type="file"
                      id="upload_image"
                      onChange={this.onSelectFile}
                      ref={this.fileInput}
                    ></input>
                  </label>
                  {this.state.imageFileError && (
                    <p className="toast">
                      {this.state.imageFileError} please try again
                    </p>
                  )}
                </div>
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Item ID</span>
                </div>
                <div className="itemOutput">
                  <input
                    type="number"
                    value={this.state.orderID}
                    onChange={(e) => this.setState({ orderID: e.target.value })}
                    required
                  />
                </div>
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Item name</span>
                </div>
                <div className="itemOutput">
                  <input type="text" value={this.state.itemName}
                    onChange={(e) => this.setState({ itemName: e.target.value })}
                    required
                  />
                </div>
              </div>

              <div className="itemList d-flex align-items-center justify-content-between">
                <div className="itemLabel">
                  <span>Description</span>
                </div>
                <div className="itemOutput">
                  <input type="text" value={this.state.description}
                    onChange={(e) => this.setState({ description: e.target.value })}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="item-footer text-end">
              <button className="pop_wth_btn" onClick={this.props.closeSidebar}>Cancel</button>
              <button className="save-btn" type="submit">Save</button>

            </div>
          </form>
        </div>
      </>
    )
  }
}

export const ItemView = props => {


  function closeSidebar() {
    return;
  }



  return (
    <>
      <div className={`AddPurchaseOrders`} >
        <div className="overlay-pop" onClick={closeSidebar}></div>
        <div className="userHeader d-flex align-items-center justify-content-between">
          <div className="UserName">
            <h2>Item Details</h2>
          </div>
          <div className="iconRight" onClick={closeSidebar}>
            <img src={iconRight} alt=""></img>
          </div>
        </div>
        <div className="item-body">
          <div className="itemList d-flex align-items-center justify-content-between">
            <div className="itemLabel">
              <span>Serial</span>
            </div>
            <div className="itemOutput">
              <span>{ }</span>
            </div>
          </div>

          <div className="itemList d-flex align-items-center justify-content-between">
            <div className="itemLabel">
              <span>Item name</span>
            </div>
            <div className="itemOutput">
              <span>{ }</span>
            </div>
          </div>

          <div className="itemList d-flex align-items-center justify-content-between">
            <div className="itemLabel">
              <span>Purchase</span>
            </div>
            <div className="itemOutput">
              <span>{ }</span>
            </div>
          </div>
        </div>
        <div className="item-footer text-end">
          <button className="pop_wth_btn" onClick={closeSidebar}>Cancel</button>
          <button className="save-btn" >Save</button>

        </div>
      </div>
    </>
  )
}
const mapStateToProps = ({ UserReducer, UsersReducer, }) => ({ UserReducer, UsersReducer, });
export default connect(mapStateToProps, { fileUpload, AddWarrantyExpiration })(ItemView);